import { render, staticRenderFns } from "./Evenmenubar.vue?vue&type=template&id=20b36164&scoped=true"
import script from "./Evenmenubar.vue?vue&type=script&lang=js"
export * from "./Evenmenubar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b36164",
  null
  
)

export default component.exports